import { EmptyCartGraphic } from '@app/components/EmptyCartGraphic';
import { Box, constants, TextLink } from '@redbubble/design-system';
import { FormattedMessage } from '@redbubble/next/intl';
import styles from './EmptyCart.module.scss';

export const EmptyCart = () => (
  <Box className={styles.wrapper}>
    <EmptyCartGraphic
      message={
        <FormattedMessage defaultMessage="No items in your cart, redirecting you to explore more..." />
      }
    />
    <TextLink intent={constants.PRIMARY} href="/">
      <FormattedMessage defaultMessage="Explore Redbubble" />
    </TextLink>
  </Box>
);
